import { useState, useRef, useEffect } from 'react';
import { BookOpen, ChevronDown } from 'lucide-react';

const EXAMPLES = [
  'Ingredientes para una tarta de choclo',
  'Todo para una ensalada César',
  'Ingredientes para empanadas de carne',
  'Lo que necesito para milanesas con puré',
  'Ingredientes para una tortilla de papas',
  'Todo para hacer pizza casera',
  'Ingredientes para un guiso de lentejas',
  'Lo que necesito para fideos con salsa bolognesa',
  'Ingredientes para una carbonada',
  'Todo para hacer ñoquis con salsa',
];

interface ExamplesDropdownProps {
  onSelect: (example: string) => void;
  disabled?: boolean;
  className?: string;
}

export function ExamplesDropdown({ onSelect, disabled, className = '' }: ExamplesDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleSelect = (example: string) => {
    onSelect(example);
    setOpen(false);
  };

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        type="button"
        className="inline-flex items-center justify-center gap-2 bg-white text-gray-600 border-2 border-gray-200 py-3 px-6 text-base rounded-md cursor-pointer transition-all hover:enabled:border-gray-400 hover:enabled:text-gray-800 hover:enabled:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed max-md:w-full h-full"
        onClick={() => setOpen(!open)}
        disabled={disabled}
      >
        <BookOpen className="w-4 h-4" />
        Ideas rápidas
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute left-0 max-md:right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[340px] max-md:min-w-0 max-md:w-full py-1">
          {EXAMPLES.map((example) => (
            <button
              key={example}
              type="button"
              className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 bg-transparent border-0 cursor-pointer transition-colors hover:bg-green-50 hover:text-green-700"
              onClick={() => handleSelect(example)}
            >
              {example}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
